import { gql } from '@apollo/client'

import { SubscriptionFragment } from '../fragments'

export const MUTATION_SUBSCRIPTION_START = gql`
  mutation startSubscription($input: SubscriptionStartInput!) {
    startSubscription(input: $input) {
      ...SubscriptionFragment
    }
  }
  ${SubscriptionFragment}
`

export const MUTATION_SUBSCRIPTION_STOP = gql`
  mutation stopSubscription($input: SubscriptionStopInput!) {
    stopSubscription(input: $input) {
      ...SubscriptionFragment
    }
  }
  ${SubscriptionFragment}
`

export const MUTATION_SUBSCRIPTION_START_AS_ADMIN = gql`
  mutation adminStartSubscription($input: SubscriptionStartInput!) {
    adminStartSubscription(input: $input) {
      ...SubscriptionFragment
    }
  }
  ${SubscriptionFragment}
`

export const MUTATION_SUBSCRIPTION_STOP_AS_ADMIN = gql`
  mutation adminStopSubscription($input: SubscriptionStopInput!) {
    adminStopSubscription(input: $input) {
      ...SubscriptionFragment
    }
  }
  ${SubscriptionFragment}
`
